declare namespace $ {

	export class $mol_icon_puzzle extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=puzzle.view.tree.d.ts.map